import { createAction, createSlice } from "@reduxjs/toolkit";

const getCourseLearningSlice = createSlice({
  name: "getCourseLearning",
  initialState: { data: null, processing: false },
  reducers: {
    pending(state) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      state.processing = false;
      state.data = action.payload.data;
      /* TODO: reducer for success*/
    },
    failure(state) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
    clearData(state) {
      state.processing = false;
      state.data = null;
    },
    updateCompleteStatus(state, action) {
      let sections = [...state.data.sections];
      for (let i = 0; i < sections.length; i++) {
        for (let j = 0; j < sections[i].lessons.length; j++) {
          if (sections[i].lessons[j].id === action.payload.id) {
            sections[i].lessons[j].isCompleted = action.payload.isCompleted;
          }
        }
      }
      state.data = {
        ...state.data,
        sections,
      };
    },
  },
});

const { name, actions, reducer } = getCourseLearningSlice;
const getCourseLearningAction = createAction(name);
const clearCourseLearningAction = actions.clearData;

export {
  getCourseLearningAction,
  clearCourseLearningAction,
  actions as getCourseLearningActions,
  reducer as getCourseLearningReducer,
};
